import request from "../../utils/request";

// 获取群活码列表数据
export function getList(authorization, params) {
  return request({
    url: "/api/qywechat/groupCode/list",
    method: "get",
    params,
    headers: {
      authorization: authorization,
    },
  });
}

//   删除群活码
export function deleteCode(authorization, id) {
  return request({
    url: `/api/qywechat/groupCode/del/${id}`,
    method: "delete",
    headers: {
      authorization: authorization,
    },
  });
}
// 获取群活码详情数据
export function getCodeDetail(authorization, params) {
  return request({
    url: `/api/qywechat/groupCode/getActualCode/${params}`,
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}
//   下载群活码
export function downCode(authorization, params) {
  return request({
    url: `/api/qywechat/groupCode//download/${params}`,
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}
//   新增群活码
export function createCode(authorization, data) {
  return request({
    url: `/api/qywechat/groupCode/add`,
    method: "post",
    data,
    headers: {
      authorization: authorization,
    },
  });
}

//   编辑群活码
export function editCode(authorization, data) {
  return request({
    url: `/api/qywechat/groupCode/update`,
    method: "put",
    data,
    headers: {
      authorization: authorization,
    },
  });
}

//   是否停用活码
export function stopCode(authorization, params) {
  return request({
    url: `/api/qywechat/groupCode/qrstatus`,
    method: "get",
    params,
    headers: {
      authorization: authorization,
    },
  });
}

//   获取活码进群详情
export function getGroupCodeDetail(authorization, id) {
  return request({
    url: `/api/qywechat/groupCode/groupdetail/${id}`,
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}

///-----------------------------end----------------------------
//   查询群标签列表
export function getGroupTag(authorization) {
  return request({
    url: "/api/qywechat/group_chat/tag",
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}
//   删除所打的群聊标签
export function deleteGroupTags(authorization, params, isloading = false) {
  return request(
    {
      url: `/api/qywechat/group_chat/tag/del?chatId=${params.chatId}&tagId=${params.tagId}`,
      method: "delete",
      headers: {
        authorization: authorization,
      },
    },
    isloading
  );
}
//   群聊打标签
export function addTagItems(authorization, params, isloading = false) {
  return request(
    {
      url: "/api/qywechat/group_chat/tag/add",
      method: "post",
      data: params,
      headers: {
        authorization: authorization,
      },
    },
    isloading
  );
}

// 查看群聊消息
export function getGroupMsg(params, authorization, isloading = true) {
  return request(
    {
      url: "/api/qywechat/group_chat/msg",
      method: "post",
      data: {
        chatId: params.chatId,
        msgType: params.msgType,
        startTime: params.startTime,
        endTime: params.endTime,
        current: params.current,
        size: params.size,
      },
      headers: {
        authorization: authorization,
      },
    },
    isloading
  );
}
//   删除标签组
export function delTagGroup(params, authorization, isloading = false) {
  return request(
    {
      url: `/api/qywechat/group_chat/tagdel?groupId=${params}`,
      method: "delete",
      headers: {
        authorization: authorization,
      },
    },
    isloading
  );
}

//   同步群聊消息
export function getGroupMessage(authorization, isloading = false) {
  return request(
    {
      url: `/api/qywechat/group_chat/syn`,
      method: "get",
      headers: {
        authorization: authorization,
      },
    },
    isloading
  );
}
